import { Box, styled } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { toggleRefreshGlobal } from 'store/commonSlice'
import { selectCurrentUserFunctions } from 'store/selectors'
import { checkFunctionHaveCode } from 'store/user/functions'

const NavItemWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: '0.75em',
    padding: '0.75em 0',
    fontWeight: 500,
    marginTop: '0.5em',
    color: '#44494d',
    '&:hover': {
        backgroundColor: 'rgb(68 73 77 / 22%)'
    },
    '&.nav-active': {
        color: theme.palette.primary.main,
        '& svg path': {
            fill: theme.palette.primary.main,
        },

    }
}))

const SidebarItem = ({
    code,
    path,
    Icon,
    labelKey,
    requiredCodes,
    onClose
}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const functions = useSelector(selectCurrentUserFunctions)

    const handleToggleRefresh = () => {
        onClose?.()
        dispatch(toggleRefreshGlobal())
    }

    if (path === true) return null;
    // Use requiredCodes if provided, otherwise fall back to code
    const codesToCheck = requiredCodes && requiredCodes.length > 0 ? requiredCodes : code;

    if (codesToCheck && codesToCheck.length) {
        const hasPermission = codesToCheck.some(c => (
            checkFunctionHaveCode(functions, c)
        ));

        if (!hasPermission) return null;
    }

    return (
        <NavLink to={path} onClick={handleToggleRefresh} style={{ textDecoration: 'none' }}>
            {({ isActive, isPending }) => (
                <NavItemWrapper
                    component="div"
                    className={clsx('nav-item', {
                        'nav-active': isActive,
                        'nav-pending': isPending
                    })}
                    display={'flex'}
                    alignItems={'center'}
                    sx={(theme) => ({
                        flexDirection: { xs: 'row', sm: 'column' },
                        columnGap: 1,
                        '&.nav-active': {
                            borderLeft: {
                                xs: '0',
                                sm: `3px solid ${theme.palette.primary.main}`,
                            }
                        }
                    })}
                >
                    {Icon}
                    {t(labelKey)}
                </NavItemWrapper>
            )}
        </NavLink>
    )
}

export default SidebarItem
